import { render } from "./AppImageGallery.vue?vue&type=template&id=f8a5d278"
import script from "./AppImageGallery.vue?vue&type=script&lang=js"
export * from "./AppImageGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__